// Russian Beginner Vocabulary - 50 unique items
// Each item supports 5 question types: target↔english, target↔romanization, definition→target

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const russianBeginnerItems: VocabularyItem[] = [
  // Greetings & Basic Phrases (1-10)
  {
    id: 'ru-beg-001',
    target: 'Привет',
    english: 'Hello (informal)',
    romanization: 'Privet',
    definition: 'A casual greeting among friends',
    partOfSpeech: 'interjection'
  },
  {
    id: 'ru-beg-002',
    target: 'Здравствуйте',
    english: 'Hello (formal)',
    romanization: 'Zdravstvuyte',
    definition: 'A formal greeting for strangers or elders',
    partOfSpeech: 'interjection'
  },
  {
    id: 'ru-beg-003',
    target: 'До свидания',
    english: 'Goodbye',
    romanization: 'Do svidaniya',
    definition: 'A farewell expression when parting',
    partOfSpeech: 'interjection'
  },
  {
    id: 'ru-beg-004',
    target: 'Спасибо',
    english: 'Thank you',
    romanization: 'Spasibo',
    definition: 'An expression of gratitude',
    partOfSpeech: 'interjection'
  },
  {
    id: 'ru-beg-005',
    target: 'Пожалуйста',
    english: 'Please / You\'re welcome',
    romanization: 'Pozhaluysta',
    definition: 'A polite word for requests or responses',
    partOfSpeech: 'interjection'
  },
  {
    id: 'ru-beg-006',
    target: 'Извините',
    english: 'Excuse me / Sorry',
    romanization: 'Izvinite',
    definition: 'An apology or attention-getting phrase',
    partOfSpeech: 'interjection'
  },
  {
    id: 'ru-beg-007',
    target: 'Да',
    english: 'Yes',
    romanization: 'Da',
    definition: 'Affirmative response',
    partOfSpeech: 'adverb'
  },
  {
    id: 'ru-beg-008',
    target: 'Нет',
    english: 'No',
    romanization: 'Net',
    definition: 'Negative response',
    partOfSpeech: 'adverb'
  },
  {
    id: 'ru-beg-009',
    target: 'Доброе утро',
    english: 'Good morning',
    romanization: 'Dobroye utro',
    definition: 'A morning greeting',
    partOfSpeech: 'interjection'
  },
  {
    id: 'ru-beg-010',
    target: 'Спокойной ночи',
    english: 'Good night',
    romanization: 'Spokoynoy nochi',
    definition: 'A nighttime farewell or bedtime greeting',
    partOfSpeech: 'interjection'
  },

  // Pronouns & People (11-20)
  {
    id: 'ru-beg-011',
    target: 'Я',
    english: 'I',
    romanization: 'Ya',
    definition: 'First person singular pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'ru-beg-012',
    target: 'Ты',
    english: 'You (informal)',
    romanization: 'Ty',
    definition: 'Informal second person singular pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'ru-beg-013',
    target: 'Он',
    english: 'He',
    romanization: 'On',
    definition: 'Third person singular masculine pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'ru-beg-014',
    target: 'Она',
    english: 'She',
    romanization: 'Ona',
    definition: 'Third person singular feminine pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'ru-beg-015',
    target: 'Мы',
    english: 'We',
    romanization: 'My',
    definition: 'First person plural pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'ru-beg-016',
    target: 'Друг',
    english: 'Friend (male)',
    romanization: 'Drug',
    definition: 'A male person you know well and like',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-017',
    target: 'Семья',
    english: 'Family',
    romanization: 'Semya',
    definition: 'Members of your household or relatives',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-018',
    target: 'Учитель',
    english: 'Teacher (male)',
    romanization: 'Uchitel',
    definition: 'A male person who teaches',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-019',
    target: 'Студент',
    english: 'Student (male)',
    romanization: 'Student',
    definition: 'A male person who studies',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-020',
    target: 'Человек',
    english: 'Person',
    romanization: 'Chelovek',
    definition: 'A human being',
    partOfSpeech: 'noun'
  },

  // Numbers (21-30)
  {
    id: 'ru-beg-021',
    target: 'Один',
    english: 'One',
    romanization: 'Odin',
    definition: 'The number 1',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-022',
    target: 'Два',
    english: 'Two',
    romanization: 'Dva',
    definition: 'The number 2',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-023',
    target: 'Три',
    english: 'Three',
    romanization: 'Tri',
    definition: 'The number 3',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-024',
    target: 'Четыре',
    english: 'Four',
    romanization: 'Chetyre',
    definition: 'The number 4',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-025',
    target: 'Пять',
    english: 'Five',
    romanization: 'Pyat',
    definition: 'The number 5',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-026',
    target: 'Шесть',
    english: 'Six',
    romanization: 'Shest',
    definition: 'The number 6',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-027',
    target: 'Семь',
    english: 'Seven',
    romanization: 'Sem',
    definition: 'The number 7',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-028',
    target: 'Восемь',
    english: 'Eight',
    romanization: 'Vosem',
    definition: 'The number 8',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-029',
    target: 'Девять',
    english: 'Nine',
    romanization: 'Devyat',
    definition: 'The number 9',
    partOfSpeech: 'number'
  },
  {
    id: 'ru-beg-030',
    target: 'Десять',
    english: 'Ten',
    romanization: 'Desyat',
    definition: 'The number 10',
    partOfSpeech: 'number'
  },

  // Common Nouns (31-40)
  {
    id: 'ru-beg-031',
    target: 'Вода',
    english: 'Water',
    romanization: 'Voda',
    definition: 'Clear liquid essential for life',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-032',
    target: 'Хлеб',
    english: 'Bread',
    romanization: 'Khleb',
    definition: 'Baked food made from flour',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-033',
    target: 'Чай',
    english: 'Tea',
    romanization: 'Chay',
    definition: 'A hot beverage made from tea leaves',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-034',
    target: 'Книга',
    english: 'Book',
    romanization: 'Kniga',
    definition: 'Written or printed pages bound together',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-035',
    target: 'Дом',
    english: 'House / Home',
    romanization: 'Dom',
    definition: 'A building where people live',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-036',
    target: 'Кошка',
    english: 'Cat',
    romanization: 'Koshka',
    definition: 'A small furry pet animal that meows',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-037',
    target: 'Собака',
    english: 'Dog',
    romanization: 'Sobaka',
    definition: 'A domesticated animal that barks',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-038',
    target: 'Машина',
    english: 'Car',
    romanization: 'Mashina',
    definition: 'A vehicle with four wheels',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-039',
    target: 'Телефон',
    english: 'Phone',
    romanization: 'Telefon',
    definition: 'A device for communication',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-beg-040',
    target: 'Деньги',
    english: 'Money',
    romanization: 'Dengi',
    definition: 'Currency used to buy things',
    partOfSpeech: 'noun'
  },

  // Common Verbs & Actions (41-50)
  {
    id: 'ru-beg-041',
    target: 'Есть',
    english: 'To eat',
    romanization: 'Yest',
    definition: 'To consume food through the mouth',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-042',
    target: 'Пить',
    english: 'To drink',
    romanization: 'Pit',
    definition: 'To consume liquids',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-043',
    target: 'Смотреть',
    english: 'To look / To watch',
    romanization: 'Smotret',
    definition: 'To use eyes to observe something',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-044',
    target: 'Слушать',
    english: 'To listen',
    romanization: 'Slushat',
    definition: 'To use ears to perceive sound',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-045',
    target: 'Говорить',
    english: 'To speak',
    romanization: 'Govorit',
    definition: 'To communicate using words',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-046',
    target: 'Читать',
    english: 'To read',
    romanization: 'Chitat',
    definition: 'To look at and understand written words',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-047',
    target: 'Писать',
    english: 'To write',
    romanization: 'Pisat',
    definition: 'To form letters or words on a surface',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-048',
    target: 'Идти',
    english: 'To go (on foot)',
    romanization: 'Idti',
    definition: 'To move by walking',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-049',
    target: 'Знать',
    english: 'To know',
    romanization: 'Znat',
    definition: 'To have information in your mind',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-beg-050',
    target: 'Любить',
    english: 'To love',
    romanization: 'Lyubit',
    definition: 'To have strong affection for someone',
    partOfSpeech: 'verb'
  }
];
